"use client";

// Forgot password — public. Sends a reset link to the rep's email.

import Link from "next/link";
import { Suspense, useActionState } from "react";
import { useSearchParams } from "next/navigation";
import { AuthCard, useAuthStyles } from "@/components/auth/AuthCard";
import { requestPasswordReset, type ResetRequestState } from "./actions";

export default function ForgotPasswordPage() {
  // useSearchParams needs a Suspense boundary on a statically rendered page.
  return (
    <Suspense>
      <ForgotPasswordForm />
    </Suspense>
  );
}

function ExpiredNotice({ style }: { style: object }) {
  const expired = useSearchParams().get("expired") === "1";
  return expired ? <p style={style}>That link expired or was already used. Request a new one.</p> : null;
}

function ForgotPasswordForm() {
  const s = useAuthStyles();
  const [state, formAction, pending] = useActionState<ResetRequestState, FormData>(
    requestPasswordReset,
    undefined,
  );

  return (
    <AuthCard>
      {state && "sent" in state ? (
        <p style={s.message("info")}>
          If that email has a Frontline account, a reset link is on its way. Open it on this
          device to choose a new password.
        </p>
      ) : (
        <form action={formAction}>
          <ExpiredNotice style={s.message("error")} />
          <p style={s.message("info")}>Enter your email and we&apos;ll send a link to choose a new password.</p>
          <div style={{ marginBottom: 18 }}>
            <label htmlFor="email" style={s.label}>
              Email
            </label>
            <input id="email" name="email" type="email" required autoComplete="email" style={s.input} />
          </div>
          {state && "error" in state && <div style={s.message("error")}>{state.error}</div>}
          <button type="submit" disabled={pending} style={s.primary(pending)}>
            {pending ? "…" : "Send reset link"}
          </button>
        </form>
      )}
      <Link href="/login" style={s.link}>
        Back to log in
      </Link>
    </AuthCard>
  );
}
